module.exports = __webpack_public_path__ + "static/media/ins-1.265f5e5d.jpg";